import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

export const PROCESSING_LATEST_EMAIL_MESSAGE =
  "Still processing this thread's latest email...";

// Kit bubble shown instead of the empty state while the thread's latest email is processing
export function ProcessingLatestEmailMessage() {
  return (
    <div
      role='status'
      className='w-full rounded-xl rounded-tl-sm border border-neutral-400 bg-neutral-100 px-3 py-2'
    >
      <Flex direction='col' gap='xs' className='w-full pl-2'>
        <Typography
          as='span'
          variant='body-xs'
          weight='medium'
          className='text-neutral-800 whitespace-nowrap'
        >
          {PROCESSING_LATEST_EMAIL_MESSAGE}
        </Typography>
      </Flex>
    </div>
  );
}
